// Generic status badge. Colors are semantic: green = healthy/active,
// yellow = degraded/warning, red = critical/down, gray = unknown/inactive/
// disconnected, purple = pending, blue = informational, indigo = in inventory.
//
// `inventory` is its own colour rather than another grey on purpose. A number or a
// device we own and have not deployed is a perfectly healthy state — it is stock —
// whereas grey in this palette means "inactive, unknown, or disconnected", i.e.
// something is wrong or unanswered. Sharing that grey made a stocked DID look
// indistinguishable from one whose status nobody could determine.
//
// Add new status keys as Verso domain surfaces new lifecycle states.

const STATUS_STYLES = {
  active:       'bg-green-100 text-green-700',
  healthy:      'bg-green-100 text-green-700',
  warning:      'bg-yellow-100 text-yellow-700',
  degraded:     'bg-yellow-100 text-yellow-700',
  critical:     'bg-red-100 text-red-700',
  down:         'bg-red-100 text-red-700',
  inactive:     'bg-gray-100 text-gray-500',
  unknown:      'bg-gray-100 text-gray-500',
  disconnected: 'bg-gray-100 text-gray-500',
  info:         'bg-blue-100 text-blue-700',
  pending:      'bg-purple-100 text-purple-700',
  inventory:    'bg-indigo-100 text-indigo-700',
};

const DOT_STYLES = {
  active:       'bg-green-500',
  healthy:      'bg-green-500',
  warning:      'bg-yellow-500',
  degraded:     'bg-yellow-500',
  critical:     'bg-red-500',
  down:         'bg-red-500',
  inactive:     'bg-gray-400',
  unknown:      'bg-gray-400',
  disconnected: 'bg-gray-400',
  info:         'bg-blue-500',
  pending:      'bg-purple-500',
  inventory:    'bg-indigo-500',
};

export default function StatusBadge({ status, label }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.unknown;
  const dot = DOT_STYLES[status] || DOT_STYLES.unknown;
  const text = label || status;

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${style}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {text}
    </span>
  );
}
